import { flashes } from 'pkg/actions';
import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { withSdk } from 'pkg/core/with_sdk';
import { crash } from 'pkg/errors/errors';

export interface ContactPerson {
	userId?: number;
	role: string;
}

export interface UpdateSiteGroupPayload {
	name?: string;
	slug?: string;
	attachmentId?: number;
	groupBy?: string;
	contactPersons?: ContactPerson[];
	players?: number[];
}

export async function update(
	siteGroup: models.siteGroup.SiteGroup,
	organizationId: number,
	payload: UpdateSiteGroupPayload
) {
	const response = await withSdk(
		'patch',
		endpoints.SiteGroups.Update(organizationId, siteGroup.id)
	)(payload);

	if (!response) {
		const c = crash();

		flashes.show({
			title: c.title,
			message: c.description,
		});
	}

	return response;
}

interface RemoveContactPersonProps {
	organizationId: number;
	siteGroup: models.siteGroup.SiteGroup;
	contactPerson: models.siteGroupContactPerson.SiteGroupContactPerson;
}

export async function removeContactPerson({
	organizationId,
	siteGroup,
	contactPerson,
}: RemoveContactPersonProps) {
	const ok = await withSdk(
		'delete',
		endpoints.SiteGroups.DeleteContactPerson(
			organizationId,
			siteGroup.id,
			contactPerson.id
		)
	)();

	if (!ok) {
		return false;
	}

	return ok;
}
